import React from 'react'
import BlackToWhite from '../black_to_white'
import Youtube from "../video";
import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: 150px;
  @media(max-width: 768px) {
    margin-bottom: 0;
  }
`

const YoutubeEmbed = ({module}) => {

  return (
    <BlackToWhite>
      <Container>
        <Youtube embedId={module.video_id} />
      </Container>
    </BlackToWhite>
  )
}

export default YoutubeEmbed
